import React from 'react';

import Chip from '@mui/material/Chip';

import { TaskStatus } from 'stores/TicketStoreAdapter';

const TaskStatusColor: Record<TaskStatus, string> = {
  NOT_STARTED: '#757575',
  IN_PROGRESS: '#ed6c02',
  DONE: '#2e7d32',
  CLOSED: '#455a64',
};

type Props = {
  status: TaskStatus;
  size?: 'small' | 'medium';
};

/** タスクステータス（未着手/着手中/完了/クローズ）を表示するチップ */
const TaskStatusChip: React.FC<Props> = ({ status, size = 'small' }) => {
  const color = TaskStatusColor[status];
  return (
    <Chip
      label={TaskStatus[status]}
      size={size}
      sx={{
        color: '#fff',
        backgroundColor: color,
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default TaskStatusChip;
